import React from 'react';
import ReactDOM from 'react-dom';
import { createStore, applyMiddleware, compose } from 'redux';
import { ToastContainer } from 'react-toastify';
import {registerLocale, setDefaultLocale} from 'react-datepicker';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import { LocalizeProvider } from 'react-localize-redux';
import * as serviceWorker from './serviceWorker';
import App from './components/App';
import rootReducer from './reducers';

import 'react-toastify/dist/ReactToastify.css';
import 'react-datepicker/dist/react-datepicker.min.css';

import ja from 'date-fns/locale/ja';
registerLocale('ja', ja);
setDefaultLocale('ja');

const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
export const store = createStore(rootReducer, composeEnhancer(applyMiddleware(thunk)));

ReactDOM.render(
  <LocalizeProvider>
    <Provider store={store}>
      <App />
      <ToastContainer />
    </Provider>
  </LocalizeProvider>,
  document.getElementById('root'),
);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
